// extracted by mini-css-extract-plugin
module.exports = {"container":"staff_section-module--container--2qj2W","background":"staff_section-module--background--LsxFg","static":"staff_section-module--static--_kVv1"};